// src/KurumResetPasswordPage.js
import React, { useEffect, useState } from "react";
import axios from "axios";

export default function KurumResetPasswordPage() {
  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null);

  /* =====================================================
     🔐 TOKEN OKUMA (HASH ROUTER UYUMLU)
     #/kurum/reset-password?token=XXXX
  ===================================================== */
  useEffect(() => {
    const hash = window.location.hash;
    if (!hash || !hash.includes("?")) {
      setMsg({ type: "error", text: "Geçersiz bağlantı." });
      return;
    }

    const qs = hash.split("?")[1];
    const params = new URLSearchParams(qs);
    const t = params.get("token");

    if (!t) {
      setMsg({ type: "error", text: "Şifre sıfırlama anahtarı bulunamadı." });
      return;
    }

    setToken(t);
  }, []);

  /* =====================================================
     🔐 SUBMIT
  ===================================================== */
  const submit = async (e) => {
    e.preventDefault();
    setMsg(null);

    if (!password || !password2) {
      setMsg({ type: "error", text: "Tüm alanlar zorunludur." });
      return;
    }

    if (password !== password2) {
      setMsg({ type: "error", text: "Şifreler uyuşmuyor." });
      return;
    }

    if (password.length < 6) {
      setMsg({ type: "error", text: "Şifre en az 6 karakter olmalıdır." });
      return;
    }

    try {
      setLoading(true);

      await axios.post("/api/kurum-passport/reset-password", {
        token,
        password,
      });

      setMsg({
        type: "success",
        text: "Şifreniz başarıyla güncellendi. Giriş sayfasına yönlendiriliyorsunuz…",
      });

      setTimeout(() => {
        window.location.href = "/#/";
      }, 2000);

    } catch (err) {
      setMsg({
        type: "error",
        text: "Bağlantı geçersiz veya süresi dolmuş olabilir.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0B1E3F] via-[#0F2D59] to-[#1B3C82] px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8">

        <h1 className="text-2xl font-bold text-center text-gray-800 mb-2">
          Kurumsal Şifre Yenileme
        </h1>

        <p className="text-center text-gray-500 text-sm mb-6">
          Kurum paneli için yeni bir şifre belirleyin
        </p>

        {msg && (
          <div
            className={`mb-4 text-sm text-center font-semibold p-3 rounded-lg ${
              msg.type === "error"
                ? "bg-red-100 text-red-700"
                : "bg-green-100 text-green-700"
            }`}
          >
            {msg.text}
          </div>
        )}

        {!msg || msg.type !== "success" ? (
          <form onSubmit={submit} className="space-y-4">
            <input
              type="password"
              placeholder="Yeni Şifre"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-600"
              required
            />

            <input
              type="password"
              placeholder="Yeni Şifre (Tekrar)"
              value={password2}
              onChange={(e) => setPassword2(e.target.value)}
              className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-600"
              required
            />

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-bold transition"
            >
              {loading ? "Kaydediliyor…" : "Şifreyi Güncelle"}
            </button>
          </form>
        ) : null}

      </div>
    </div>
  );
}
